import React, { useCallback, useRef, useState } from 'react'
import debounce from 'lodash.debounce'
import async from 'async-es'

import pretty from '@st-operations/uikit/lib/pretty'

import Select from '_components/select'
import { SELECT_ACTIONS } from '_components/select/constants'

import searchEntities from '_lib/searchEntities'

const TemplateSelect = ({ handleSelectTemplate }) => {
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const lastRequestId = useRef(0)

  const formatName = (name) => {
    const prettifiedName = pretty(name)
    return prettifiedName.length > 60
      ? `${prettifiedName.slice(0, 30)}...${prettifiedName.slice(prettifiedName.length - 30)}`
      : prettifiedName
  }

  const onSelectChange = (item, { action }) =>
    item && action === SELECT_ACTIONS.SELECT_OPTION && handleSelectTemplate(item.value)

  const searchAudiences = (query) => {
    if (!query) return

    const currentRequestId = ++lastRequestId.current
    setLoading(true)

    const entityOptions = []
    async.each(
      [{ kind: 'custom', limit: 10, query, status: 'draft,approved,processed' }],
      (options, next) => {
        searchEntities('audiences', options, (entities) => {
          entities.forEach((entity) => {
            entityOptions.push({
              label: formatName(entity.name),
              value: entity,
            })
          })
          next()
        })
      },
      (error) => {
        // Only update if latest request
        if (currentRequestId === lastRequestId.current && !error) {
          setOptions(entityOptions)
          setLoading(false)
        }
      }
    )
  }

  const debouncedSearchAudiences = useCallback(debounce(searchAudiences, 300), [])

  const handleInputChange = (query, { action }) => {
    if (action === SELECT_ACTIONS.INPUT_CHANGE) {
      debouncedSearchAudiences(query)
    }
  }

  const noOptionsMessage = () => (loading ? 'Loading...' : 'Type to search')

  return (
    <Select
      label="Template Audience"
      placeholder="search audiences"
      options={options}
      onChange={onSelectChange}
      onInputChange={handleInputChange}
      isSearchable={true}
      noOptionsMessage={noOptionsMessage}
    />
  )
}

export default TemplateSelect
